export default __webpack_public_path__ + "static/media/ico_share_bus.782571de.svg";